import CircularProgress from '@mui/material/CircularProgress';
import logo from '../assets/HGP_Logo.png'


export const Loading = () => {
  return( 
    <>
        <img src={logo} style={{position:'absolute',width:'230px',marginTop:"12px", height:'230px'}} />
        <CircularProgress color="primary" style={{width:'230px', height:'230px'}} /> 
    </>
  )
}